// Libraries
import moment, { Moment } from "moment";
import momentTZ from "moment-timezone";

// Types & Interfaces
import { Nullable } from "@/Common/interfaces/types";
import { IReviewData, IReviewSiteSummary } from "@/DataPages/types/socialMediaReviews/model";
import { ITransformedData, IUserReview, IUsersReview } from "../interfaces";

// Helpers
import {
	extractColumnsFromReviewsNew,
	getStoreUniqueSiteNames,
	prepareDataReputationReviewsNew as prepareReputationDataReviews,
	prepareDataStoreReviews,
} from "@DataPages/helpers/socialMediaReviews/reviews";
import { DATE_FORMAT } from "@/Constants/date";

function getTransformedReputationData(reviewData: Nullable<IReviewData>): ITransformedData | null {
	if (!reviewData) {
		return null;
	}

	const { storeReviews, updatedAt, usersReviews, onDemand } = reviewData ?? {};
	const formattedUpdatedAt = updatedAt ? moment(updatedAt).format(DATE_FORMAT.usDateTime12hPadded) : "";

	const transformedData: ITransformedData = {
		usersReviews: [{ positionTitle: "", positionName: "", columns: [], rows: [] }],
		updatedAt: formattedUpdatedAt,
		dataStoreReviews: [],
		storeReviewsColumns: [],
		onDemand,
	};

	transformedData["usersReviews"] = (usersReviews as unknown as IUsersReview[])?.map((reviewData: IUsersReview) => {
		return {
			positionTitle: String(reviewData?.positionTitle),
			...prepareReputationDataReviews(reviewData),
		};
	});

	if (storeReviews) {
		transformedData["dataStoreReviews"] = prepareDataStoreReviews(storeReviews as unknown as IReviewSiteSummary[]) || [];
		const uniqueStoreColumnNames = getStoreUniqueSiteNames(storeReviews as unknown as IReviewSiteSummary[]);
		transformedData["storeReviewsColumns"] = extractColumnsFromReviewsNew(uniqueStoreColumnNames, "store") || [];
	}

	return transformedData;
}

function getAssociateOptions(data: IUserReview[] | undefined): string[] {
	if (!data?.length) {
		return [];
	}

	return data.filter((item) => item.positionTitle).map((item) => item.positionTitle);
}

function getTabContent(options: string[], tabId: number, pageContent: IUserReview[]) {
	if (!options?.length) {
		return;
	}

	const position = options[tabId];
	const positionsContentArray = Array.isArray(pageContent) ? pageContent : [pageContent];
	return positionsContentArray.find((positionObj) => positionObj.positionTitle === position);
}

function getStartOfDay(date: string): Moment {
	return momentTZ(momentTZ(date).utc(false).endOf("day").toISOString());
}
function getEndOfDay(date: string): Moment {
	return momentTZ(momentTZ(date).utc(false).endOf("day").toISOString());
}

export { getTransformedReputationData, getAssociateOptions, getTabContent, getStartOfDay, getEndOfDay };
